import request from '@/router/axios';

// 财务租后短信配置管理-筛选条件-可选择人员列表
export const loanPostFinancialLeaseList = (params) => {
  return request({
    url: '/api/blade-LoanPostFinancialLease/loanPost/LoanPostFinancialLeaseList',
    method: 'get',
    params
  })
}


// 短信 财务人员分配-信息
export const financePersonnelDistributionInfo = (userId) => {
  return request({
    url: '/api/blade-LoanPostFinancialLease/loanPost/finance-personnel-distribution-info',
    method: 'post',
    data: (function () {
      var form = new FormData();
      form.append("userId", userId);
      return form;
    })(),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
  })
}

// 短信 财务人员分配
export const financePersonnelDistribution = (data) => {
  return request({
    url: '/api/blade-LoanPostFinancialLease/loanPost/finance-personnel-distribution',
    method: 'post',
    data
  })
}

// 财务租后业务推送配置管理-筛选条件-可选择人员列表
export const financialLeaseBusinessNumberList = (params) => {
  return request({
    url: '/api/blade-LoanPostFinancialLease/loanPost/financialLease-business_number-list',
    method: 'get',
    params
  })
}


// 业务推送 财务人员分配-信息
export const financePersonnelBusinessNumber = (userId) => {
  return request({
    url: '/api/blade-LoanPostFinancialLease/loanPost/finance-personnel-business-number',
    method: 'post',
    data: (function () {
      var form = new FormData();
      form.append("userId", userId);
      return form;
    })(),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
  })
}

// 业务推送 财务人员分配
export const financeBusinessNumber = (data) => {
  return request({
    url: '/api/blade-LoanPostFinancialLease/loanPost/finance-business-number',
    method: 'post',
    data
  })
}
